<div class="menu">
  <a class="option" routerLink="/profile" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Profile</a>
  <a class="option" routerLink="/profile/history" routerLinkActive="active">History</a>
  <a class="option" routerLink="/profile/transactions" routerLinkActive="active">Transactions</a>
  <a class="option" routerLink="/profile/self-exclusion" routerLinkActive="active">Self-Exclusion</a>
</div>
